"use client";
import { Link } from "@/i18n/navigation";
import { useTranslations } from "next-intl";
import styles from "./FooterNavLink.module.scss";

interface IFooterNavLink {
  href: string;
  title: string;
}

const FooterNavLink: React.FC<IFooterNavLink> = ({ href, title }) => {
  const t = useTranslations("FooterNavList");

  return (
    <Link className={styles.link} href={href}>
      {t(title)}
      <svg
        viewBox="0 0 7 12"
        fill="currentColor"
        width="18"
        height="100%"
        className={styles.link__icon}
      >
        <use href="/images/sprite.svg#arrow-1-right"></use>
      </svg>
    </Link>
  );
};

export default FooterNavLink;
